export default __webpack_public_path__ + "static/media/fa-v4compatibility.2ec4574b.woff2";